<div class="select" *ngIf="deviceSettingsService">
  <qai-label
    class="mic-text"
    [kind]="'secondary'"
    [size]="'medium'"
    [weight]="'bold'"
  >
    {{'settings.SELECT_MICROPHONE' | transloco}}
  </qai-label>

  <div class="select-item">
    <div class="select-left">
      <qai-icon [kind]="'microphone'" [color]="'#475467'" [size]="'24px'" />

      <div
        class="select-input select-error"
        *ngIf="deviceSettingsService?.audioDeviceError"
      >
        <qai-icon [kind]="'alert-circle'" [color]="'#D92D20'" [size]="'20px'">
        </qai-icon>
        {{ deviceSettingsService.audioDevicePlaceholder }}
      </div>

      <mat-select
        *ngIf="!deviceSettingsService.audioDeviceError"
        [(value)]="deviceSettingsService.audioDeviceSelected"
        [disabled]="!deviceSettingsService.displayAudioOptions"
        [class.hide-arrow]="
          !deviceSettingsService.displayAudioOptions ||
          deviceSettingsService.audioDeviceOptions.length < 2
        "
        [disabled]="
          !deviceSettingsService.displayAudioOptions ||
          deviceSettingsService.audioDeviceOptions.length < 2
        "
        (selectionChange)="handleSelectMicClick()"
        [placeholder]="deviceSettingsService.audioDevicePlaceholder"
        panelClass="device-settings-content-mat-select"
      >
        <mat-option
          *ngFor="let item of deviceSettingsService.audioDeviceOptions"
          [value]="item.deviceId"
        >
          {{ item.label || "Default Mic" }}
        </mat-option>
      </mat-select>
    </div>

    <!-- Give Permission button -->
    <button
      *ngIf="deviceSettingsService.isPermissionDismissedAudio"
      qai-button
      [shape]="'normal'"
      [kind]="'primary'"
      [size]="'large'"
      (click)="
        deviceSettingsService.givePermission(deviceSettingsService.audioDevice)
      "
      class="give-permission-button"
    >
      {{'settings.GIVE_PERMISSION' | transloco}}
    </button>
  </div>
</div>
